import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { Fragment, useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconArrowRight from "@iconify/icons-eva/arrow-ios-forward-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, TextField, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, IconButton } from "@mui/material";
// components
import Page from "src/components/Page";
import Label from "src/components/Label";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
// import USERLIST from '../_mocks_/user';

import axios from "axios";
import { BASE_URL } from "src/config/constants";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import { ArrowRight } from "@mui/icons-material";
import ListHead from "src/components/common/ListHead";


const TABLE_HEAD = [
  { id: "uid", label: "菜单名称", alignRight: false }, 
  { id: "icon", label: "图标", alignRight: false }, 
  { id: "route", label: "菜单地址", alignRight: false }, 
  { id: "api", label: "权限api", alignRight: false }, 
  { id: "order", label: "排序", alignRight: false }, 
  { id: "isShow", label: "是否显示", alignRight: false }, 
  { id: "createdAt", label: "创建时间", alignRight: false }, 
  { id: "operation" }
];

const moreMenus = [
  { title: "添加子菜单", icon: plusFill },
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

export default function AgentMenu() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [menus, setMenus] = useState([]);
  const [foldMap, setFoldMap] = useState({});

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [form, setForm] = useState({
    icon: "",
    name: "",
    route: "",
    api: "",
    order: 0,
    isMenu: true,
    isShow: true,
    pid: 0,
    pName: "",
  });

  useEffect(() => {
    getMenus();
  }, []);

  function getMenus() {
    axios
      .get("/agent/menu/all")
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (!data.length) return;
          const menus = [...data];
          menus.sort((a, b) => b.order - a.order);

          const levels = [];

          for (let i = 0; i < menus.length; i++) {
            const level = (menus[i].level || 1) - 1;
            if (!levels[level]) {
              levels[level] = [];
            }

            levels[level].push(menus[i]);
          }

          for (let i = levels.length - 1; i > 0; i--) {
            for (let j = 0; j < levels[i].length; j++) {
              const parentGroup = levels[i - 1];
              const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

              if (!parent.children) {
                parent.children = [];
              }

              parent.children.push(levels[i][j]);
            }
          }

          setItems(levels[0]);
          setMenus(data);
        }
      })
      .catch((err) => {});
  }

  function handleAddMenu(pid = 0, pName = "顶级") {
    console.log("dasd");
    setForm({
      icon: "",
      name: "",
      route: "",
      order: 0,
      isMenu: true,
      isShow: true,
      pid,
      pName,
    });
    setAction("add");
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`edit/${row.id}`);
      let pid = 0;
      let pName = "顶级";
      if (row.pid) {
        const parent = menus.find((m) => m.id === row.pid);
        pid = parent.id;
        pName = parent.name;
      }

      setTargetItem({ ...row });
      setAction("edit");
      setForm({
        isMenu: row.isMenu,
        isShow: row.isShow,
        icon: row.icon,
        order: row.order,
        name: row.name,
        route: row.route,
        api: row.api,
        pid,
        pName,
      });
    } else if (type === "删除") {
      handleDelBanner(row.id);
    } else if (type === "添加子菜单") {
      handleAddMenu(row.id, row.name);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/agent/menu/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              // setItems(items.filter((b) => b.id !== id));
              getMenus();
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除权限失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleDialogConfirm() {
    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    axios
      .post(action === "add" ? "/agent/menu/add" : "/agent/menu/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          getMenus();

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改权限失败: ", err);
      });
  }

  function toggleShow(id, to) {
    axios
      .post("/agent/menu/toggleShow", {
        id,
        isShow: to,
      })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          getMenus();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("修改权限失败: ", err);
      });
  }

  function handleFolding(row) {
    // console.log(row.pid, row.name, foldMap);
    setFoldMap({
      ...foldMap,
      [row.id]: !foldMap[row.id],
    });
  }

  const isUserNotFound = items.length === 0;

  function renderTableRow(list, visible = true) {
    if (!list) return null;
    return list.map((row) => {
      const { id, name, icon, isShow, createdAt, route, api, order, level, pid, children } = row;

      if (visible) {
        visible = foldMap[pid];
      }

      let display = "none";
      if (level === 1 || visible) {
        display = "";
      }

      return (
        <Fragment key={id}>
          <TableRow hover key={id} tabIndex={-1} role="checkbox" sx={{ display }}>
            <TableCell align="left" sx={{ pl: level - 1 }}>
              <IconButton onClick={() => handleFolding(row)} disabled={!children}>
                <ArrowRight sx={{ visibility: !children ? "hidden" : "visible", transform: `rotate(${foldMap[id] ? 90 : 0}deg)` }} />
              </IconButton>
              {name}
            </TableCell>
            <TableCell align="left">{icon}</TableCell>
            <TableCell align="left">{route}</TableCell>
            <TableCell align="left">{api}</TableCell>
            <TableCell align="left">{order}</TableCell>
            <TableCell align="left">
              <Switch checked={isShow} onChange={e => toggleShow(id, e.target.checked)} />  
            </TableCell>
            <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
            <TableCell align="right">
              <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
            </TableCell>
          </TableRow>
          {renderTableRow(children, visible)}
        </Fragment>
      );
    });
  }

  return (
    <Page title="商户菜单管理">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商户菜单管理
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddMenu()}>
            添加菜单
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} rowCount={items.length} />

                <TableBody>{renderTableRow(items)}</TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {/* <SearchNotFound searchQuery={filterName} /> */}
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>

      <FormDialog title={action === "add" ? "添加菜单" : "修改菜单"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="父级菜单">
          <TextField fullWidth placeholder="父级菜单" autoComplete="off" id="pName" value={form.pName} size="small" disabled />
        </FormItem>

        {/* <FormItem title="菜单图标">
          <Stack direction="row">
            {!form.image ? null : <img src={`${BASE_URL}${form.image}`} style={{ maxWidth: 200, maxHeight: 200 }} />}
            <Uploader onUploaded={handleUploaded} />
          </Stack>
        </FormItem> */}

        <FormItem title="菜单类型" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isMenu}>
            <FormControlLabel value={true} control={<Radio />} label="菜单" onChange={(e) => handleIptChange("isMenu", e.target.value)} />
            <FormControlLabel value={true} control={<Radio />} label="权限" onChange={(e) => handleIptChange("isMenu", e.target.value)} />
          </RadioGroup>
        </FormItem>

        <FormItem title="菜单名" required>
          <TextField fullWidth placeholder="菜单名" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>

        <FormItem title="菜单图标" required>
          <TextField fullWidth placeholder="菜单图标" autoComplete="off" id="icon" value={form.icon} size="small" onChange={(e) => handleIptChange("icon", e.target.value)} />
        </FormItem>

        <FormItem title="页面路由">
          <TextField fullWidth placeholder="页面路由" autoComplete="off" id="route" value={form.route} size="small" onChange={(e) => handleIptChange("route", e.target.value)} />
        </FormItem>

        <FormItem title="接口路由">
          <TextField fullWidth placeholder="接口路由" autoComplete="off" id="api" value={form.api} size="small" onChange={(e) => handleIptChange("api", e.target.value)} />
        </FormItem>

        <FormItem title="排序" required>
          <TextField fullWidth placeholder="排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
        </FormItem>

        <FormItem title="权限状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
            <FormControlLabel value={true} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            <FormControlLabel value={false} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          </RadioGroup>
        </FormItem>
      </FormDialog>
    </Page>
  );
}
